import jsonp from 'jsonp';

import { numberUnmask } from '~/utils/mask';
import { setFormData } from '~/utils/form';
import errorHandler from '~/utils/errorHandler';

async function SearchCnpjService({
  setLoadingCnpj,
  formRef,
  setErrorHandlerData,
  handleSearchZipCode,
}) {
  setLoadingCnpj(true);

  const cpf_cnpj = formRef.current && formRef.current.getFieldValue('cpf_cnpj');
  const cnpjUnmasked = numberUnmask(cpf_cnpj);

  if (cnpjUnmasked && cnpjUnmasked.length === 14) {
    await new Promise(resolve =>
      jsonp(
        `https://www.receitaws.com.br/v1/cnpj/${cnpjUnmasked}`,
        (error, res) => {
          if (error) {
            const errorParsed = errorHandler({
              error,
              title: 'Erro ao buscar CNPJ',
              local: 'SearchCnpjService',
            });

            setErrorHandlerData({ error: errorParsed });
          } else if (!res.erro && !res.message) {
            const auxTel = res.telefone.split('/');

            const formData = {
              first_name: res.nome,
              last_name: res.fantasia,
              email: res.email,
              ddd1: numberUnmask(auxTel[0]).slice(0, 2),
              telephone1: numberUnmask(auxTel[0]).slice(2),
              zip_code: numberUnmask(res.cep),
            };

            if (auxTel.length > 1) {
              formData.ddd2 = numberUnmask(auxTel[1]).slice(0, 2);
              formData.telephone2 = numberUnmask(auxTel[1]).slice(2);
            }

            setFormData({ formRef, formData });

            if (res.cep) handleSearchZipCode();
          } else {
            setErrorHandlerData({
              error: {
                title: 'CNPJ inválido',
                message: 'Favor verificar o CNPJ',
              },
            });
          }
          resolve();
        }
      )
    );
  } else {
    setErrorHandlerData({
      error: {
        title: 'Quantidade inválida de caracteres',
        message: 'Somente é possível buscar CNPJ e com 14 caracteres',
      },
    });
  }

  setLoadingCnpj(false);
}

export default SearchCnpjService;
